import { createAction, props } from '@ngrx/store';
import { MedioDePago } from 'src/app/pago/enums/MedioDePago.enum';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { ErrorPago } from 'src/app/pago/models/ErrorPago.model';
import { ModalError } from 'src/app/pago/models/ModalError.model';
import { Pago } from 'src/app/pago/models/Pago.model';

export const loadConfiguracionDePago = createAction(
  '[Pago] Consultar pago',
  props<{ idPago: string }>()
);

export const saveConfiguracionDePago = createAction(
  '[Maestros] Guardar pago consultado',
  props<{ configuracionDePago: ConfiguracionDePago }>()
);

export const loadConfiguracionDePagoFailed = createAction(
  '[Pagos] Error consultando pago',
  props<{ error: ErrorPago[] }>()
);

export const registerPago = createAction(
  '[Pagos] Registrar pago',
  props<{ pago: Pago }>()
);

export const registerPagoSuccess = createAction(
  '[Maestros] Pago registrado correctamente'
);

export const registerPagoFailed = createAction(
  '[Pagos] Falló el registro del pago',
  props<{ error: ErrorPago[] }>()
);

export const errorEnPago = createAction(
  '[Pagos] Ocurrio un error en el pago',
  props<{ error: ModalError }>()
);

export const loadPago = createAction(
  '[Pago] Consultar estado pago',
  props<{ idPago: string }>()
);

export const savePago = createAction(
  '[Pago] Guardar estado pago consultado',
  props<{ pago: Pago }>()
);

export const clearError = createAction('[Pago] Limpiar error');

export const changeRenovacionAutomatica = createAction(
  '[Pago] Activar o desactivar renovación automática',
  props<{ activarRenovacionAutomatica: boolean }>()
);

export const changeMedioDePago = createAction(
  '[Pago] Cambiar medio de pago',
  props<{ medioDePago: MedioDePago }>()
);

export const setInitialPagoState = createAction('[Pago] Limpiar pago');

export const registerOtroMedioDePago = createAction(
  '[Pagos] Registrar otro medio de pago',
  props<{ pago: Pago }>()
);

export const registerOtroMedioDePagoSuccess = createAction(
  '[Pagos] Registrando otro medio de pago',
  props<{ urlRedirectOtroMedioDePago: string }>()
);

export const registerOtroMedioDePagoFailed = createAction(
  '[Pagos] Error registrando otro medio de pago',
  props<{ error: ErrorPago[] }>()
);

export const saveTenant = createAction(
  '[Pagos] Se guarda el tenant',
  props<{ tenant: string }>()
);

export const saveProductNameFromUrl = createAction(
  '[Pagos] Se guarda el nombre del producto desde el queryParam en la url',
  props<{ productName: string }>()
);

export const idPagoInvalidFromUrl = createAction(
  '[Pagos] El idPago en la url es inválido',
  props<{ error: ErrorPago[] }>()
);

export const consultarEstadoPagoFailed = createAction(
  '[Pagos] Falló la consulta del estado del pago',
  props<{ error: ErrorPago[] }>()
);
